/**
 * @generated SignedSource<<8a4e5c861022c3fb9703172d1a7755a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProfileGdprExportMutation$variables = {};
export type ProfileGdprExportMutation$data = {
  readonly gdpr: {
    readonly result: boolean | null;
  } | null;
};
export type ProfileGdprExportMutation = {
  response: ProfileGdprExportMutation$data;
  variables: ProfileGdprExportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GDPRExportMutation",
    "kind": "LinkedField",
    "name": "gdpr",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileGdprExportMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileGdprExportMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "452a46272e45b2e226ec7ab3b4469ac7",
    "id": null,
    "metadata": {},
    "name": "ProfileGdprExportMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileGdprExportMutation {\n  gdpr {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "b058c0e5937339e498d0a44d1e0e7eea";

export default node;
